import React from "react";
import { useTranslation } from "react-i18next";
import { useDocTitle } from "../../components/_common/DocTitle";

/** Material-UI */
import { Button, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { GetApp /*ChevronRight*/ } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    bigTitle: {
        margin: theme.spacing(4, 4, 4, 4),
        textAlign: "center",
        justifyContent: "center",
        fontSize: "2rem",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.125rem",
            fontWeight: theme.typography.fontWeightMedium,
        },
    },
    sectionTitle: {
        fontSize: "1.5rem",
        textAlign: "center",
        margin: theme.spacing(6, 0),
    },

    fagTitle: {
        fontSize: "1.25rem",
        fontWeight: 600,
        textAlign: "center",
        margin: theme.spacing(0, 0, 4, 0),
    },
    userManualWrapper: { 
        display: "flex", 
        flexDirection: "row", 
        alignItems: "flex-start", 
        gap: 16, 
        [theme.breakpoints.down("sm")]: { 
            flexDirection: "column", 
            alignItems: "center", 

        }, },
    preview: {
        width: "100%",
        maxWidth: "350px",
        height: "auto",
        objectFit: "contain",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "250px",
        },
    },


content: {
    fontSize: "1.25rem",
    [theme.breakpoints.down("sm")]: {
        fontSize: "1rem",
        textAlign: "center",
    },
},

    buttonWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: theme.spacing(8, 0),
    },
}));

const POMOC_Page = (props) => {
    const classes = useStyles();
    const { i18n, t } = useTranslation();
    useDocTitle("Pomoc - Repozytorium Systemów Informacyjnych");
    return (
        <>
            <Typography
                variant="h4"
                className={classes.bigTitle}
                color="primary"
                component={"h2"}
                id={"page-content"}
                tabIndex={0}
            >
                {t("pages.help")}
            </Typography>

            {/* <Divider />

            <Typography
                variant="h4"
                className={classes.sectionTitle}
                color="primary"
                component={"h3"}
                id={"page-content"}
                tabIndex={0}
            >
                {t(
                    "Przewodnik użytkownika dla jednostek prowadzących systemy informacyjne administracji publicznej{{kr}}",
                    { kr: "." }
                )}
            </Typography>

            <div className={classes.userManualWrapper}>
                <img
                    src={`/${i18n.language}/images/przewodnik_uzytkownika.png`}
                    alt={t("Podręcznik użytkownika")}
                    className={classes.preview}
                />

                <Typography variant={"body1"} className={classes.content}>
                    {t(
                        "Praktyczne wskazówki jak zaktualizować lub sporządzić opis systemu/rejestru w Systemie Metadanych Statystycznych (SMS), w dedykowanym modelu dla RSI{{kr}}",
                        { kr: "." }
                    )}
                </Typography>
            </div>

            <div className={classes.buttonWrapper}>
                <Button
                    variant={"contained"}
                    color={"primary"}
                    startIcon={<GetApp />}
                    style={{ padding: "6px 32px" }}
                    href={`/files/Przewodnik_użytkownika_RSI_2024_listopad.pdf`}
                    target={"_blank"}
                >
                    {t(`POBIERZ Przewodnik użytkownika RSI (PDF, {{size}} MB)`, {
                        size: i18n.language === "pl" ? "1,24" : "1.24",
                    })}
                </Button>
            </div>

            <Divider /> */}

            <Typography
                variant="h4"
                className={classes.sectionTitle}
                color="primary"
                component={"h3"}
                id={"page-content"}
                tabIndex={0}
            >
                {t("Samouczek RSI")}
            </Typography>

            <div className={classes.userManualWrapper}>
                 <img
                    src={`/${i18n.language}/images/samouczek_rsi.png`}
                    alt={t("Podręcznik użytkownika")}
                    className={classes.preview}
                />
                <Typography variant={"body1"} className={classes.content}>
                    {t(
                        "Pomoc w poruszaniu się po głównych zakładkach Portalu RSI{{kr}}",
                        { kr: "." }
                    )}
                </Typography>
            </div>

            <div className={classes.buttonWrapper}>
                <Button
                    variant={"contained"}
                    color={"primary"}
                    startIcon={<GetApp />}
                    style={{ padding: "6px 32px" }}
                    href={`/files/Samouczek_RSI_Portal_2025.pdf`}
                    target={"_blank"}
                >
                    {t(`POBIERZ Samouczek RSI (PDF, {{size}} MB)`, {
                        size: i18n.language === "pl" ? "3,3" : "3.3",
                    })}
                </Button>
            </div>

            <Divider />
        </>
    );
};

export default POMOC_Page;
